export const TABLES_BUTTON = 'tables';
export const SQL_BUTTON = 'sql';
export const CSV_BUTTON = 'csv';
export const SAVED_QUERIES_BUTTON = 'saved-queries';
